// airportCoords.js
// Covers all Singapore Airlines destinations + fixes coordinate errors
export const AIRPORT_COORDS = {

  // ── Hub ──────────────────────────────────────────────────────────────────
  'SIN': [1.3644,   103.9915],  // Singapore Changi

  // ── Southeast Asia ───────────────────────────────────────────────────────
  'BKK': [13.6900,  100.7501],  // Bangkok Suvarnabhumi
  'DMK': [13.9126,  100.6069],  // Bangkok Don Mueang
  'CNX': [18.7668,   98.9626],  // Chiang Mai
  'HKT': [8.1132,    98.3169],  // Phuket
  'USM': [9.5478,   100.0620],  // Koh Samui
  'KUL': [2.7456,   101.7099],  // Kuala Lumpur
  'PEN': [5.2971,   100.2769],  // Penang
  'CGK': [-6.1256,  106.6559],  // Jakarta
  'DPS': [-8.7467,  115.1670],  // Bali Ngurah Rai
  'SUB': [-7.3798,  112.7870],  // Surabaya
  'MNL': [14.5086,  121.0194],  // Manila
  'CEB': [10.3075,  123.9795],  // Cebu
  'SGN': [10.8188,  106.6519],  // Ho Chi Minh City
  'HAN': [21.2212,  105.8072],  // Hanoi
  'RGN': [16.9073,   96.1324],  // Yangon
  'REP': [13.4107,  103.8130],  // Siem Reap
  'PNH': [11.5466,  104.8442],  // Phnom Penh
  'VTE': [17.9883,  102.5633],  // Vientiane
  'BWN': [4.9442,   114.9283],  // Bandar Seri Begawan
  'SAI': [11.5466,  104.8442],  // (alias sometimes used for Phnom Penh area)

  // ── Northeast Asia ───────────────────────────────────────────────────────
  'HKG': [22.3080,  113.9185],  // Hong Kong
  'PEK': [40.0799,  116.6031],  // Beijing Capital
  'PKX': [39.5098,  116.4105],  // Beijing Daxing
  'PVG': [31.1443,  121.8083],  // Shanghai Pudong
  'SHA': [31.1981,  121.3368],  // Shanghai Hongqiao
  'CAN': [23.3924,  113.2988],  // Guangzhou
  'SZX': [22.6393,  113.8109],  // Shenzhen
  'XMN': [24.5440,  118.1278],  // Xiamen
  'CTU': [30.5785,  103.9470],  // Chengdu
  'CKG': [29.7192,  106.6417],  // Chongqing
  'WUH': [30.7838,  114.2081],  // Wuhan
  'CSX': [28.1892,  113.2200],  // Changsha
  'FOC': [25.9351,  119.6633],  // Fuzhou
  'NKG': [31.7420,  118.8620],  // Nanjing
  'HGH': [30.2295,  120.4339],  // Hangzhou
  'KMG': [24.9924,  102.7434],  // Kunming
  'NNG': [22.6083,  108.1725],  // Nanning
  'XIY': [34.4471,  108.7516],  // Xi'an
  'TNA': [36.8574,  117.2160],  // Jinan
  'SHE': [41.6398,  123.4833],  // Shenyang
  'DLC': [38.9657,  121.5386],  // Dalian
  'TAO': [36.2661,  120.3745],  // Qingdao
  'NRT': [35.7720,  140.3929],  // Tokyo Narita
  'HND': [35.5494,  139.7798],  // Tokyo Haneda
  'KIX': [34.4272,  135.2440],  // Osaka Kansai  ← was missing / wrong code
  'NGO': [34.8584,  136.8054],  // Nagoya
  'FUK': [33.5859,  130.4508],  // Fukuoka
  'OKA': [26.1958,  127.6461],  // Okinawa
  'OSA': [34.4347,  135.2440],  // Osaka (generic alias → same as KIX)
  'ICN': [37.4602,  126.4407],  // Seoul Incheon
  'TPE': [25.0797,  121.2342],  // Taipei Taoyuan
  'MFM': [22.1496,  113.5916],  // Macau

  // ── South Asia ───────────────────────────────────────────────────────────
  'DEL': [28.5562,   77.1000],  // New Delhi
  'BOM': [19.0896,   72.8656],  // Mumbai
  'BLR': [13.1979,   77.7063],  // Bengaluru
  'HYD': [17.2403,   78.4294],  // Hyderabad
  'MAA': [12.9941,   80.1709],  // Chennai
  'CCU': [22.6547,   88.4467],  // Kolkata
  'AMD': [23.0772,   72.6347],  // Ahmedabad
  'COK': [10.1520,   76.4019],  // Kochi
  'CMB': [7.1808,    79.8841],  // Colombo
  'DAC': [23.8433,   90.3978],  // Dhaka
  'KTM': [27.6966,   85.3591],  // Kathmandu
  'MLE': [4.1918,    73.5290],  // Male (Maldives)

  // ── Middle East ──────────────────────────────────────────────────────────
  'DXB': [25.2532,   55.3657],  // Dubai
  'DOH': [25.2731,   51.6080],  // Doha
  'AUH': [24.4330,   54.6511],  // Abu Dhabi

  // ── Europe ───────────────────────────────────────────────────────────────
  'LHR': [51.4700,   -0.4543],  // London Heathrow
  'LGW': [51.1537,   -0.1821],  // London Gatwick
  'CDG': [49.0097,    2.5479],  // Paris Charles de Gaulle
  'FRA': [50.0379,    8.5622],  // Frankfurt
  'MUC': [48.3537,   11.7750],  // Munich
  'AMS': [52.3105,    4.7683],  // Amsterdam
  'ZRH': [47.4647,    8.5492],  // Zurich
  'FCO': [41.8003,   12.2389],  // Rome Fiumicino
  'MXP': [45.6306,    8.7281],  // Milan Malpensa
  'BCN': [41.2974,    2.0833],  // Barcelona
  'MAD': [40.4983,   -3.5676],  // Madrid
  'IST': [41.2753,   28.7519],  // Istanbul
  'CPH': [55.6181,   12.6560],  // Copenhagen
  'OSL': [60.1976,   11.1004],  // Oslo
  'ARN': [59.6519,   17.9186],  // Stockholm Arlanda
  'HEL': [60.3172,   24.9633],  // Helsinki
  'VIE': [48.1103,   16.5697],  // Vienna
  'BRU': [50.9014,    4.4844],  // Brussels
  'ATH': [37.9364,   23.9445],  // Athens
  'MAN': [53.3537,   -2.2750],  // Manchester

  // ── Oceania ──────────────────────────────────────────────────────────────
  'SYD': [-33.9399,  151.1753],  // Sydney
  'MEL': [-37.6690,  144.8410],  // Melbourne
  'BNE': [-27.3942,  153.1218],  // Brisbane
  'PER': [-31.9403,  115.9672],  // Perth
  'ADL': [-34.9462,  138.5306],  // Adelaide
  'OOL': [-28.1644,  153.5047],  // Gold Coast
  'CNS': [-16.8858,  145.7452],  // Cairns
  'AKL': [-37.0082,  174.7850],  // Auckland
  'CHC': [-43.4894,  172.5322],  // Christchurch  ← was missing

  // ── Africa ───────────────────────────────────────────────────────────────
  'JNB': [-26.1367,   28.2411],  // Johannesburg

  // ── Americas ─────────────────────────────────────────────────────────────
  'JFK': [40.6413,   -73.7781],  // New York JFK
  'EWR': [40.6895,   -74.1745],  // New York Newark
  'LAX': [33.9416,  -118.4085],  // Los Angeles
  'SFO': [37.6213,  -122.3790],  // San Francisco  ← was pointing to Auckland!
  'HOU': [29.6454,   -95.2789],  // Houston Hobby (fifth-freedom)

  // ── Cargo / occasional tech-stop airports (include for completeness) ─────
  'SZB': [3.1306,   101.5461],   // Kuala Lumpur Subang
};

// Helper functions
export const getAirportCoords = (iataCode) => {
  return AIRPORT_COORDS[iataCode] || null;
};

export const isValidAirport = (iataCode) => {
  return iataCode in AIRPORT_COORDS;
};